export enum HttpStatusCodes {
  Unauthorized = 401,
  Forbidden = 403,
  BadRequest = 400,
  Conflict = 409,
  UnprocessableEntity = 422,
  InternalServerError = 500,
  GatewayTimeout = 504,
  ConnectionError = 0
}
